import type { AxiosError } from 'axios';

// Local mirror of the api deposit-limit 403 contract (CP-007b). The Orval client
// doesn't carry this shape yet (regenerate with `yarn generate-api` once the api
// ships it); until then the interceptor matches the 403 body here — same pattern
// as the KYC / territory interceptors.

export type DepositLimitWindow = 'DAILY' | 'WEEKLY' | 'MONTHLY';

/** 403 body thrown by DepositService.createIntent when a per-player cap is breached. */
export interface DepositLimitExceededBody {
  code: 'DEPOSIT_LIMIT_EXCEEDED';
  message?: string;
  window: DepositLimitWindow;
  limitCents: number;
  remainingCents: number;
}

/**
 * True for the structured 403 a deposit-limit breach throws. The deposit form
 * uses this to suppress its generic inline error — the gate popup
 * (installDepositLimitInterceptor) owns the UX for this case.
 */
export function isDepositLimitExceededError(err: unknown): boolean {
  const e = err as AxiosError | undefined;
  const body = e?.response?.data as DepositLimitExceededBody | undefined;
  return e?.response?.status === 403 && body?.code === 'DEPOSIT_LIMIT_EXCEEDED';
}
